var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnpinnedSlash = function SvgUnpinnedSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.1 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 11.7v7.5c0 .4.4.8.8.8s.8-.4.8-.8v-5.9l-1.6-1.6ZM9.2 5.3h1.6v3l2.3 2.3c1.6-1 2.6-2.8 2.6-4.9C15.8 2.6 13.2 0 10 0S6.2 1.1 5.1 2.6l4 4V5.3Zm.8-3.6c1.1 0 2 .5 2 1.2s-.9 1.2-2 1.2-2-.5-2-1.2.9-1.2 2-1.2ZM9 11.5 4.3 6.8C4.7 9.2 6.6 11 9 11.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 5.3H9.2v1.4l1.7 1.6v-3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 4c1.1 0 2-.5 2-1.2s-.9-1.2-2-1.2-2 .5-2 1.2S8.9 4 10 4Z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 19.7c.3-.3.3-.8 0-1.1l-7.5-7.5-1.4-1.4-1.6-1.6-4.6-4.5L1.4.3S1.2.2 1.1.1H.6S.4.1.3.3c-.3.2-.3.5-.1.8 0 0 0 .2.2.3l10.5 10.5 7.8 7.8s.2.1.3.2h.4s.2 0 .3-.2Z"
  })));
};
export default SvgUnpinnedSlash;